export default __webpack_public_path__ + "static/media/acumatica_logo.f9c0bad3.png";